import { OAuthLayout, OAuthSuccessContent } from '@features/OAuth';

export default function OAuthSuccessPage() {
  return (
    <OAuthLayout>
      <OAuthSuccessContent />
    </OAuthLayout>
  );
}
